import { Row } from "@tanstack/react-table";
import { uniqueStrings } from "./sorting";
import { sortArrayByKey } from "./sorting";

export function getColumnValues<T>(columnId: string, rows: Row<T>[]) {
    return sortArrayByKey(
        uniqueStrings(rows.map((row) => row.getValue(columnId)) ?? []),
        (x) => x,
    );
}
